import { Component } from '@angular/core';

import { ConfigurationPage } from "../configuration/configuration";

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {
  tabOrderSelectionRoot: any = ConfigurationPage;
  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts